class EventElement {
    constructor(element) {
        this.element = element;
        this.handlers = {};
        this.useCaptures = {};
    }

    bind(eventName, handler,useCapture) {
        if (typeof this.handlers[eventName] === 'undefined') {
            this.handlers[eventName] = [];
        }
        this.handlers[eventName].push(handler)
        this.useCaptures[eventName]=useCapture
        const list = eventName.split(',');
        if(list.length>0){
            for (let i = 0; i < list.length; i++) {
                this.element.addEventListener(list[i], handler, useCapture);
            }
        }
    }

    unbind(eventName, target) {
        let hlist=this.handlers[eventName];
        if (typeof hlist === 'undefined') {
            //
        }else {
            this.handlers[eventName] = hlist.filter(handler => {
                if (target) {
                    if (handler !== null) {
                        if (target && handler !== target) {
                            return true;
                        }
                    } else {
                        handler = target;
                    }
                    let useCapture = false;
                    if (this.useCaptures.hasOwnProperty(eventName)) {
                        useCapture = this.useCaptures[eventName];
                        delete this.useCaptures[eventName];
                    }
                    const list = eventName.split(',');
                    if (list.length > 0) {
                        for (let i = 0; i < list.length; i++) {
                            this.element.removeEventListener(list[i], handler, useCapture);
                        }
                    }
                }
                return false;
            });
        }
    }

    unbindWN(eventName) {
        let hlist=this.handlers[eventName];
        if (typeof hlist === 'undefined') {
            //
        }else {
            this.handlers[eventName] = hlist.filter(handler => {
                if (handler !== null) {
                    let useCapture = false;
                    if (this.useCaptures.hasOwnProperty(eventName)) {
                        useCapture = this.useCaptures[eventName];
                        delete this.useCaptures[eventName];
                    }
                    const list = eventName.split(',');
                    if (list.length > 0) {
                        for (let i = 0; i < list.length; i++) {
                            this.element.removeEventListener(list[i], handler, useCapture);
                        }
                    }
                    return false;
                }
                return true;
            });
        }
    }

    unbindAll() {
        for (const name in this.handlers) {
            this.unbindWN(name);
        }
    }

    get isEmpty() {
        return Object.keys(this.handlers).every(
            key => this.handlers[key].length === 0
        );
    }
}

export default class EventManager {
    constructor() {
        this.eventElements = [];
    }

    eventElement(element) {
        let ee = this.eventElements.filter(ee => ee.element === element)[0];
        if (!ee) {
            ee = new EventElement(element);
            this.eventElements.push(ee);
        }
        return ee;
    }

    bind(element, eventName, handler,useCapture) {
        this.eventElement(element).bind(eventName, handler,useCapture);
    }

    unbind(element, eventName, handler) {
        const ee = this.eventElement(element);
        ee.unbind(eventName, handler);

        if (ee.isEmpty) {
            // remove
            this.eventElements.splice(this.eventElements.indexOf(ee), 1);
        }
    }

    unbindAll() {
        this.eventElements.forEach(e => e.unbindAll());
        this.eventElements = [];
    }

    once(element, eventName, handler) {
        const ee = this.eventElement(element);
        const onceHandler = evt => {
            ee.unbind(eventName, onceHandler);
            handler(evt);
        };
        ee.bind(eventName, onceHandler);
    }
}
